import $ST from 'plugins/tfs/platformConfigs/staticTextMaps/transferOrderDetail';
import $S from 'theme/settings';
import $U from 'plugins/tfs/platformConfigs/integrationMaps/urls';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { message } from 'antd';

import { fetchTransfers } from 'actions/transfers';
import { fetchTransferOrderDetail } from 'actions/transferOrderDetail';
import { openImageModal } from 'actions/imageModal';
import { omsCommand, clearOmsCommand } from 'actions/transferOmsCommand';
import { clientCommands } from 'appConstants';
import LayoutContentWrapper from 'components/ui-ant/utility/layoutWrapper.js';
import IndexBox from 'components/ui-ant/IndexBox';
import { DatatableBox } from 'components/ui-ant/Datatable';
import DetailList from 'components/ui-ant/DetailList';
import {
  parameterizedString,
  thumbnailImageUrl,
  dateFormatter,
} from 'theme/utils';
import Image from 'theme/Image';
import './style.css';

class TransferOrderDetail extends Component {
  componentDidMount() {
    this.getTransferOrderDetail();
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      dispatch,
      transferOrderDetail,
      omsCommandSuccess,
      omsCommandError,
      transferOrderError,
    } = this.props;
    const { orderNumber } = transferOrderDetail;

    const apiError =
      (transferOrderError &&
        prevProps.transferOrderError !== transferOrderError) ||
      (omsCommandError && prevProps.omsCommandError !== omsCommandError);

    if (
      omsCommandSuccess &&
      prevProps.omsCommandSuccess !== omsCommandSuccess
    ) {
      this.onActionSuccess();
      dispatch(clearOmsCommand());
    }
    if (apiError) {
      this.onActionFail();
    }
    if (prevProps.transferOrderDetail === transferOrderDetail) return;
    if (orderNumber) dispatch(fetchTransfers(orderNumber));
  }

  columns = () => {
    const {
      dispatch,
      transferOrderDetail: {
        source: { name: sourceName },
        destination: { name: destinationName },
        transferTargetDate,
      },
    } = this.props;
    const {
      packageOrderDetailModalImageHeight: height,
      packageOrderDetailModalImageWidth: width,
    } = $S;

    return [
      {
        key: 1,
        dataIndex: 'product.productimage_set[0].url',
        title: $ST.TABLE.COL.IMAGE,
        render: (image) => {
          return (
            <Image
              src={thumbnailImageUrl(image, 50, 50)}
              width={50}
              height={50}
              onClick={() =>
                dispatch(
                  openImageModal(thumbnailImageUrl(image, width, height))
                )
              }
            />
          );
        },
      },
      {
        key: 2,
        dataIndex: 'product.sku',
        title: $ST.TABLE.COL.SKU,
      },
      {
        key: 3,
        dataIndex: 'product.name',
        title: $ST.TABLE.COL.NAME,
      },
      {
        key: 4,
        dataIndex: '',
        title: $ST.TABLE.COL.DESTINATION_NAME,
        render: () => destinationName,
      },
      {
        key: 5,
        dataIndex: '',
        title: $ST.TABLE.COL.SOURCE_NAME,
        render: () => sourceName,
      },
      {
        key: 6,
        dataIndex: '',
        title: $ST.TABLE.COL.TRANSFER_DATE,
        render: () => transferTargetDate && dateFormatter(transferTargetDate),
      },
      {
        key: 7,
        dataIndex: 'state.name',
        title: $ST.TABLE.COL.STATUS,
      },
    ];
  };

  getTransferOrderDetail() {
    const {
      match: {
        params: { transferOrderId },
      },
      dispatch,
    } = this.props;
    dispatch(fetchTransferOrderDetail(transferOrderId));
  }

  actionsMapper() {
    const {
      transferOrderDetail: { commands = [] },
      pendingAnyAction,
    } = this.props;

    return commands.map((serverCommand, index) => {
      const isInstoreCommand =
        serverCommand &&
        serverCommand.ui_visibility &&
        serverCommand.ui_visibility.includes('instore');
      const clientCommand = clientCommands.find(
        (_clientCommand) =>
          _clientCommand.command === serverCommand.command && isInstoreCommand
      );

      const actions = {
        ...clientCommand,
        ...serverCommand,
        pendingAnyAction,
        ...(isInstoreCommand ? serverCommand : {}),
      };

      return actions;
    });
  }

  onActionClick = (actionParams) => {
    const {
      transferOrderDetail: { id },
    } = this.props;
    this.omsCommand(id, actionParams);
  };

  onActionSuccess = () => {
    message.success($ST.MESSAGE.SUCCESS);
    this.getTransferOrderDetail();
  };

  onActionFail = () => {
    message.error($ST.MESSAGE.ERROR);
    this.getTransferOrderDetail();
  };

  omsCommand = (id, actionParams) => {
    const { dispatch } = this.props;
    dispatch(omsCommand(id, null, actionParams));
  };

  createDetailList = () => {
    const {
      transferOrderDetail: {
        id,
        number,
        order,
        orderNumber,
        channelName,
        state: { name: stateName },
        source: { name: sourceName },
        destination: { name: destinationName },
        createdDate,
        shippingAddress: { title, line, city },
        customerName,
        customerSurname,
      },
    } = this.props;

    const detailObject = {
      title: number,
      detailList: [
        {
          title: $ST.TRANSFER_INFO,
          listItems: [
            {
              title: $ST.TRANSFER_NUMBER,
              description: number,
            },
            {
              title: $ST.TRANSFER_STATUS,
              description: stateName,
            },
            {
              title: $ST.STOCK_LOCATION,
              description: sourceName,
            },
            {
              title: $ST.TARGET_LOCATION,
              description: destinationName,
            },
            {
              title: $ST.TRANSFER_CREATE_DATE,
              description: createdDate && dateFormatter(createdDate),
            },
          ],
        },
        {
          title: $ST.ORDER_INFO,
          listItems: [
            {
              title: $ST.ORDER_NUMBER,
              description: orderNumber,
              eventType: 'navigate',
              eventParams: `/oms/orders/order-detail/${order}`,
            },
            {
              title: $ST.FULL_NAME,
              description: `${customerName} ${customerSurname}`,
            },
            {
              title: $ST.CHANNEL,
              description: channelName,
            },
          ],
        },
        {
          title: $ST.SHIPPING_DETAILS,
          listItems: [
            {
              title: $ST.SHIPPING_ADDRESS,
              description: `${title} ${line} ${city}`,
            },
          ],
        },
      ],
    };

    return id
      ? detailObject
      : {
          title: '',
          detailList: [],
        };
  };

  render() {
    const {
      transferOrderDetail: { id, transferItemSet, number },
      transfers,
      pending,
    } = this.props;
    const { detailList, title: detailTitle } = this.createDetailList();
    const getFiltersURL = $U.FILTERS_URL;

    return (
      <LayoutContentWrapper loading={pending} className='mt45'>
        <div className='fs25'>
          <Link className='breadcrumb-item' to='/oms/transfer-orders/'>
            {$ST.TRANSFER_ORDERS}
          </Link>
          {` > ${$ST.TRANSFER_DETAIL}`}
        </div>
        {id && transfers && (
          <DetailList detailList={detailList} title={detailTitle} />
        )}
        {transferItemSet && (
          <IndexBox
            title={parameterizedString($ST.TRANSFER_INFO_WITH_NUMBER, number)}
          >
            <DatatableBox
              actionButtons={this.actionsMapper()}
              onActionClick={this.onActionClick}
              draggable={false}
              pagination={false}
              columns={this.columns()}
              rowKey='id'
              dataSource={transferItemSet}
              filtersURL={getFiltersURL}
            />
          </IndexBox>
        )}
      </LayoutContentWrapper>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    transfers: state.transfers.transfers,
    pending: state.transfers.pending || state.transferOrderDetail.pending,
    omsCommandSuccess: state.transferOmsCommand.success,
    omsCommandError: state.transferOmsCommand.error.apiError,
    pendingAnyAction: state.transferOmsCommand.pending,
    transferOrderDetail: state.transferOrderDetail.transferOrderDetail,
    transferOrderError: state.transferOrderDetail.error.apiError,
  };
};

export default connect(mapStateToProps)(TransferOrderDetail);



// WEBPACK FOOTER //
// ./src/plugins/tfs/pages/oms/TransferOrderDetail/main/index.js